var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customizer-view"},[_c('div',{staticClass:"brand-name"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/image/logo.svg"}})])],1),_c('canvas-editor'),_c('object-selector'),_c('material-selector'),_c('option-selector'),_c('product-selector'),_c('introduction-popup'),_c('cart-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }